import gql from "graphql-tag";

const GET_UNIQUE_PROSPECTS_COUNT = gql`
    query getProspects($input: TotalProspectsCountFilter){
        getTotalProspectsCount(filter:$input)
  }
`;

export default GET_UNIQUE_PROSPECTS_COUNT